// extracted by mini-css-extract-plugin
export default {"banner":"TrialBanner_banner__2wD2t","icon":"TrialBanner_icon__lesN+"};